import React from "react";
import {
  Grid,
  Box,
  Typography,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { Form } from "@components";
import { useDispatch } from "react-redux";
import { createUserDelegate } from "@store";

type State = {
  adding: boolean;
  form: {
    values: {
      active: boolean;
      email: string;
    };
    errors: {
      active?: Error | undefined;
      email?: Error | undefined;
    };
  };
};

type Action =
  | {
      type: "reset";
    }
  | {
      type: "set-error";
      key: keyof State["form"]["values"];
      error: Error;
    }
  | {
      type: "set-value";
      key: keyof State["form"]["values"];
      value: any; // [TODO] Fix type
    }
  | {
      type: "toggle-adding";
      value?: State["adding"];
    };

function init(): State {
  return {
    adding: false,
    form: {
      values: {
        active: false,
        email: "",
      },
      errors: {},
    },
  };
}

function reducer(state: State, action: Action): State {
  switch (action.type) {
    case "reset":
      return init();
    case "set-error":
      return {
        ...state,
        form: {
          ...state.form,
          errors: {
            ...state.form.errors,
            [action.key]: action.error,
          },
        },
      };
    case "set-value":
      return {
        ...state,
        form: {
          values: {
            ...state.form.values,
            [action.key]: action.value,
          },
          errors: {
            ...state.form.errors,
            [action.key]:
              Form.Validators.hasValue(action.value) ||
              Form.Validators.isEmail(action.value),
          },
        },
      };
    case "toggle-adding":
      return {
        ...state,
        adding: action.value === undefined ? !state.adding : action.value,
      };
    default:
      return state;
  }
}

export const AddDelegate: React.FC = () => {
  const storeDispatch = useDispatch();
  const [localState, localDispatch] = React.useReducer(
    reducer,
    undefined,
    init
  );

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Box border={1} borderColor="grey.500">
          <Box
            px={2}
            py={1}
            bgcolor="#8a92a5"
            color="white"
            fontWeight="fontWeightBold"
          >
            <Typography variant="body2" color="inherit">
              Delegate Email
            </Typography>
          </Box>
          <Box p={2}>
            <Grid container spacing={2}>
              <Form.Textbox
                error={localState.form.errors.email}
                name="email"
                onChange={(key, value) => {
                  localDispatch({
                    type: "set-value",
                    key,
                    value,
                  });
                }}
                placeholder="name.lastname@globalpay.com"
                size={6}
                value={localState.form.values.email}
              />
              <Form.Checkbox
                label="Delegate is active"
                name="active"
                onChange={(key, value) => {
                  localDispatch({
                    type: "set-value",
                    key,
                    value,
                  });
                }}
                size={6}
                value={!!localState.form.values.active}
              />
            </Grid>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Button
          disabled={localState.adding}
          onClick={() => {
            const { active, email } = localState.form.values;
            const error =
              Form.Validators.hasValue(email) || Form.Validators.isEmail(email);

            if (error) {
              localDispatch({
                type: "set-error",
                key: "email",
                error,
              });
            } else {
              localDispatch({
                type: "toggle-adding",
                value: true,
              });
              Promise.resolve(
                storeDispatch(
                  createUserDelegate({
                    email,
                    active,
                  })
                )
              ).then(() => {
                localDispatch({
                  type: "reset",
                });
              });
            }
          }}
          size="small"
        >
          {localState.adding ? <CircularProgress size={22} /> : "Add"}
        </Button>
      </Grid>
    </React.Fragment>
  );
};
